import { useIframeFocus } from './useIframeFocus';

export default useIframeFocus;
